import { Drawer } from "antd";
import React, { FC, useState, useEffect } from "react";
import NotificationCard from "../NotificationCard/NotificationCard";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_NOTIFICATIONS } from "../../../store/selectors/notificationsSelectors";
import { nanoid } from "nanoid";

// список уведомлений
interface NotificationsDrawerProps {
  close: () => void;
  active: boolean;
  resetActiveMenu: () => void;
}
export const NotificationsDrawer: FC<NotificationsDrawerProps> = ({
  active,
  close,
  resetActiveMenu,
}) => {
  const [open, setOpen] = useState(active);
  const notifications = useAppSelector(SELECT_NOTIFICATIONS);
  const onClose = () => {
    resetActiveMenu();
    close();
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  return (
    <>
      <Drawer
        width={552}
        title="Уведомления"
        placement="right"
        onClose={onClose}
        open={open}
        style={{ position: "relative" }}
      >
        {Array.isArray(notifications) &&
          notifications?.map((item) => {
            const id = nanoid();
            return (
              <NotificationCard
                key={id}
                app_id={item.app_id}
                application={item.application}
                bank={item.bank}
                isNewMessage={item.isNewMessage}
                closeDrawer={onClose}
              />
            );
          })}
      </Drawer>
    </>
  );
};
